import { render, staticRenderFns } from "./BdInfo.vue?vue&type=template&id=0247a91f&scoped=true&"
import script from "./BdInfo.vue?vue&type=script&lang=js&"
export * from "./BdInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0247a91f",
  null
  
)

export default component.exports